export function timeToMinutes(time) {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}


export function isValidTimeslots(data) {
  return data.week_days.every((day) =>
    day.timeslots ? (
      day.timeslots.every(
        (slot) => timeToMinutes(slot.end_time) > timeToMinutes(slot.start_time)
      )
    ) : (
      true
    )
  );
}